<template>
    <div
        class="service-frequency__container ls-button-picker"
        :class="{ 'most-popular': mostPopular }"
        @click="selectPriceOption()"
    >
        <div
            class="ls-button ls-button--block ls-button--radio"
            :class="{
                'ls-button--green': optionSelected,
                'ls-button--faded': optionSelected && !isHomeGnome,
                'is-non-mowing': !priceOption.service.service_id,
            }"
        >
            <span
                v-if="priceOption.service.service_id"
                class="service-frequency__text-title"
                data-font-size="-1"
                test-id="cycle-text"
            >
                {{ priceOption.price.cycle | lsCycle }}
                <br v-if="!screenSize.xs" />
            </span>
            <span v-if="isLawnStarter" test-id="service-name">
                {{ priceOption.service.name | lsServiceName }}
            </span>
            <p
                v-if="priceOption.price.price"
                class="service-frequency__text-price"
                data-font-size="-3"
                test-id="service-price"
            >
                ${{ priceOption.price.price }} / service
            </p>
            <p
                v-else-if="priceOption.service.service_id"
                class="service-frequency__text-quote"
                data-font-size="-3"
                test-id="custom-option"
            >
                Custom quote
            </p>

            <span v-if="!renderAsButton" class="ls-button-toggle-icon ls-color--gray--light">
                <i
                    class="fa"
                    :class="{
                        'fa-circle-thin': !optionSelected,
                        'fa-check-circle': optionSelected,
                        'ls-color--green--color-dodge': optionSelected && isLawnStarter,
                        'll-color-primary': optionSelected && (isLawnLove || isHomeGnome),
                    }"
                ></i>
            </span>
        </div>
        <p v-if="mostPopular && isLawnStarter" class="most-popular__text" data-font-size="-2">
            Most Popular
        </p>
    </div>

    <!-- Structure to get radio select appearance -->
    <!--<label class="ls-button ls-button&#45;&#45;block ls-button&#45;&#45;radio">-->
    <!--<span class="ls-button-toggle-icon ls-color-gray&#45;&#45;light">-->
    <!--<i class="fa fa-circle-thin"></i>-->
    <!--</span>-->
    <!--</label>-->
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import VueTypes from 'vue-types';
import brandMixin from '@/mixins/brand.mixin';

export default {
    mixins: [brandMixin],
    props: {
        priceOption: VueTypes.shape({
            price: VueTypes.shape({
                price_id: VueTypes.oneOfType([VueTypes.number, null]).isRequired,
                cycle: VueTypes.number.isRequired,
                price: VueTypes.number,
            }).loose,
            service: VueTypes.shape({
                name: VueTypes.string.isRequired,
                service_id: VueTypes.oneOfType([VueTypes.number, null]).isRequired,
            }).loose,
        }).isRequired,
        selectedPriceOption: VueTypes.shape({
            price: VueTypes.shape({
                price_id: VueTypes.oneOfType([VueTypes.number, null]).isRequired,
            }).loose,
        }).loose,
        renderAsButton: VueTypes.bool,
        mostPopular: VueTypes.bool.def(false),
    },
    computed: {
        ...mapState(['screenSize']),
        optionSelected() {
            return (
                _.get(this.selectedPriceOption, 'price.price_id') ===
                _.get(this.priceOption, 'price.price_id')
            );
        },
    },
    methods: {
        selectPriceOption() {
            this.$emit('priceOptionSelected', this.priceOption);
        },
    },
};
</script>

<style lang="scss">
.service-frequency__container {
    position: relative;
    padding: 12px;
    border-radius: 3px;

    .service-frequency__text-price,
    .service-frequency__text-quote {
        margin-top: 5px;
    }

    &.most-popular {
        background: $theme-color-primary-light;
        padding-bottom: 20px;

        .ls-button-toggle-icon {
            background: $theme-color-primary-light;
        }
    }
    .most-popular__text {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 3px;
        padding: 0 12px;

        color: $theme-color-primary;
        font-weight: 800;
        text-align: center;
    }

    .is-non-mowing {
        padding: 16px 0;
    }
}

.themed-lawnlove {
    .service-frequency__container {
        .ls-button {
            &.ls-button--green {
                background: $theme-color-primary-light-hover;
                border-color: $theme-color-primary-dark;
            }
            &:hover {
                color: $theme-color-gray-darker;
                background: $theme-color-primary-light-hover;
            }
        }
        &.most-popular {
            background: transparent;
        }
    }
}

.themed-homegnome {
    .service-frequency__container {
        .ls-button {
            &.ls-button--green {
                background: $theme-color-primary;
                border-color: $theme-color-primary-dark;
            }
            &:hover {
                color: $theme-color-gray-light;
                background: $theme-color-primary;
            }
        }
        &.most-popular {
            background: transparent;
        }
    }
}
</style>
